import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { ONBOARDINGS } from '../../constants/onboardings';
import {
  getOnboardingPending,
  getOnboardingSeen,
  markOnboardingSeen,
} from '../../constants/onboarding';
import OnboardingModal from './OnboardingModal';

const shouldShow = (userId, onboarding) => {
  if (!onboarding.slides || onboarding.slides.length === 0) return false;
  if (getOnboardingSeen(userId, onboarding.id)) return false;
  // immediate: aparece sin re-login. Si no, requiere el "pending" del último login.
  if (onboarding.immediate) return true;
  return getOnboardingPending(userId, onboarding.id);
};

/**
 * Manager de onboardings: elige el primero pendiente/no visto del registro y lo
 * muestra. Al cerrarse lo marca como visto y reevalúa para mostrar el siguiente
 * (si lo hay). Se monta en el layout para aparecer en cualquier página.
 */
export const Onboarding = ({ userId, userEmail, onGoToRules }) => {
  const [tick, setTick] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const current = useMemo(
    () => (userId ? ONBOARDINGS.find((o) => shouldShow(userId, o)) || null : null),
    [userId, tick]
  );

  if (!current) return null;

  const handleClose = () => {
    markOnboardingSeen(userId, current.id);
    setTick((t) => t + 1); // reevaluar: ¿queda otro pendiente?
  };

  return (
    <OnboardingModal
      key={current.id || 'welcome'}
      onboarding={current}
      userEmail={userEmail}
      onClose={handleClose}
      onGoToRules={onGoToRules}
    />
  );
};

Onboarding.displayName = 'Onboarding';
Onboarding.propTypes = {
  userId: PropTypes.string,
  userEmail: PropTypes.string,
  onGoToRules: PropTypes.func.isRequired,
};
Onboarding.defaultProps = {
  userId: null,
  userEmail: '',
};

export default Onboarding;
